import React, { useState, useEffect, Fragment } from 'react';
import { Container, Form, Button, Alert, Row, Col, FloatingLabel } from 'react-bootstrap';
import FuncionarioService from '../../../../services/funcionarios';
import RhService from '../../../../services/rh';
import '../../../../styles/diario.scss';
import { Link } from 'react-router-dom';

const EditarHolerites = () => {
    const [funcionarios, setFuncionarios] = useState([]);
    const [filtroNome, setFiltroNome] = useState('');
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState(null);

    const [holerites, setHolerites] = useState([]);
    const [holeriteSelecionada, setHoleriteSelecionada] = useState(null);

    const [arquivo, setArquivo] = useState(null);
    const [mensagem, setMensagem] = useState('');

    const [sucesso, setSucesso] = useState(false);

    useEffect(() => {
        async function carregarFuncionarios() {
            try {
                const response = await FuncionarioService.listar();
                setFuncionarios(response.data || []);
            } catch (err) {
                console.error("Erro ao carregar funcionários:", err);
                setFuncionarios([]); // evita travar a UI
            }
        }
        carregarFuncionarios();
    }, []);

    const listaFiltrada = funcionarios.filter(f =>
        f.nome.toLowerCase().includes(filtroNome.toLowerCase())
    );

    const holeritesOrdenados = [...holerites].sort((a, b) => {
        if (a.ano !== b.ano) {
            return b.ano - a.ano; // ano desc (maior primeiro)
        }
        return b.mes - a.mes;     // mês desc (maior primeiro)
    });

    const selecionarFuncionario = async (id) => {
        setFuncionarioSelecionado(id);
        setHoleriteSelecionada(null);
        setArquivo(null);

        const response = await RhService.holerites(id);
        setHolerites(response.data["holerites"] || []);
    };

    const enviar = async () => {
        if (!arquivo || !holeriteSelecionada || !funcionarioSelecionado) return;

        const form = new FormData();
        form.append('arquivo', arquivo);
        form.append('funcionario', funcionarioSelecionado);
        form.append('holerite', holeriteSelecionada);

        try {
            const response = await RhService.trocaHolerite(form);
            if (response.data["mensagem"] == "Holerite substituído com sucesso!")
                setMensagem(response.data["mensagem"]);
            setSucesso(true);
        } catch (err) {
            setMensagem('Erro ao substituir a holerite.');
        }
    };

    const nomeMes = [
        "",            // índice 0 (não usado)
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
        "13º Salário - 1ª Parcela",
        "13º Salário - 2ª Parcela",
        "Informe Anual de Rendimentos"
    ];

    if (!sucesso) {
        return (
            <Fragment>
                <Container className="mt-4">
                    <h3>Trocar Holerite</h3>

                    {mensagem && <Alert variant="info">{mensagem}</Alert>}

                    {/* Selecionar funcionário */}
                    <Row className="mb-3 mt-4">
                        <Col lg={6}>
                            <FloatingLabel label="Buscar funcionário">
                                <Form.Control
                                    type="text"
                                    value={filtroNome}
                                    onChange={(e) => setFiltroNome(e.target.value)}
                                    placeholder="Digite para filtrar"
                                />
                            </FloatingLabel>
                        </Col>

                        <Col lg={6}>
                            <Form.Select
                                value={funcionarioSelecionado || ''}
                                onChange={(e) => selecionarFuncionario(e.target.value)}
                            >
                                <option value="">Selecione um funcionário</option>
                                {listaFiltrada.map(f => (
                                    <option value={f._id}>{f.nome}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>

                    {/* Selecionar holerite */}
                    {funcionarioSelecionado && (
                        <Row className="mb-3">
                            <Col lg={6}>
                                <Form.Select
                                    value={holeriteSelecionada || ''}
                                    onChange={(e) => setHoleriteSelecionada(e.target.value)}
                                >
                                    <option value="">Selecione mês/ano da holerite</option>
                                    {holeritesOrdenados.map(h => (
                                        <option value={h._id}>{`${nomeMes[h.mes]}/${h.ano}`}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Row>
                    )}

                    {/* Upload do arquivo */}
                    {holeriteSelecionada && (
                        <Row className="mb-3">
                            <Col lg={6}>
                                <Form.Group controlId="arquivo">
                                    <Form.Label>Selecione o novo PDF</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="application/pdf"
                                        onChange={(e) => setArquivo(e.target.files[0])}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        {/* Botão enviar */}
                        {arquivo && (
                            <Button variant="primary" onClick={enviar}>Salvar Alteração</Button>
                        )}
                    </Row>
                    <Row>
                        <Link to={'/rh/holerites'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Row>
                </Container>
            </Fragment>
        );
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Holerite substituída com sucesso!</Alert>
                <Row>
                    <Link to={`/rh/funcionarios/holerites/${funcionarioSelecionado}`}>
                        <Button variant="danger" type="button">
                            Ver Holerites do Funcionário
                        </Button>
                    </Link>
                </Row>
                <Row>
                    <Link to={'/rh/holerites'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Row>
            </Fragment>
        )
    }
}

export default EditarHolerites;